import { createSlice, current } from "@reduxjs/toolkit";

const desktop_mode_screen = { width: '600', height: '440' }

const initialState = {
    id: '',
    video_duration: 0,
    prod_upt: false,
    display_productLocation: false,
    product_location: { styleLeft: 0, styleTop: 0, config: { left: 0, top: 0, screen_width: desktop_mode_screen.width, screen_height: desktop_mode_screen.height } },
    taggedProduct: [],
    settings: {},
    video_screen: { width: desktop_mode_screen.width, height: desktop_mode_screen.height },
    video_url: '',
    video_thumbnail: '',
    stream: null,
    isPublished: 0,
    eventStatus: '',
}

export const VideoStorage = createSlice({
    name: 'VideoStorage',
    initialState,
    reducers: {
        updateVideoData: (state, action) => {
            if (action.payload.id)
                state.id = action.payload.id

            if (action.payload.video_duration) {
                state.video_duration = action.payload.video_duration
            }

            if (action.payload.hasOwnProperty('prod_upt'))
                state.prod_upt = action.payload.prod_upt

            if (action.payload.display_productLocation)
                state.display_productLocation = action.payload.display_productLocation

            if (action.payload.product_location)
                state.product_location = action.payload.product_location

            if (action.payload.taggedProduct)
                state.taggedProduct = action.payload.taggedProduct

            if (action.payload.settings)
                state.settings = action.payload.settings

            if (action.payload.video_screen)
                state.video_screen = action.payload.video_screen

            if (action.payload.video_url)
                state.video_url = action.payload.video_url

            if (action.payload.video_thumbnail)
                state.video_thumbnail = action.payload.video_thumbnail

            if (action.payload.stream)
                state.stream = action.payload.stream

            if (action.payload.hasOwnProperty('isPublished'))
                state.isPublished = action.payload.isPublished

            if (action.payload.hasOwnProperty('eventStatus'))
                state.eventStatus = action.payload.eventStatus

        },

        toggleBlinkVisibility: (state, action) => {
            const { pId, vId } = action.payload;
            const product = state.taggedProduct.find(p => p.productId === pId);
            if (product) {
                const variant = product.variants.find(v => v.id === vId);
                if (variant) variant.blinkVisible = !variant.blinkVisible;
            }
        },

        updateVariantPosition: (state, action) => {
            const { productId, variantId, position } = action.payload;
            const product = state.taggedProduct.find(p => p.productId === productId);
            if (product) {
                const variant = product.variants.find(v => v.id === variantId);
                if (variant) variant.position = position;
            }
        },

        clearVideoData: (state, action) => {
            Object.assign(state, initialState);
        }

    }
})

export const { updateVideoData, clearVideoData, toggleBlinkVisibility, updateVariantPosition } = VideoStorage.actions

export default VideoStorage.reducer